<template>
  <div>
    <div class="col-4">
      <div class="setHeight">
        <div
          class="wjTypeChild"
          :style="{ height: height + 'px' }"
          style="overflow-y: hidden; position: fixed; top: 61px; z-index: 111"
        >
          <div
            v-for="(operate, index) in tx_setting"
            :key="operate.id"
            style="text-align: center"
            class="wjTypeChildItemFont"
            :class="{
              wjTypeChildItem: index != 0,
              iconActive: $route.path == operate.path,
            }"
          >
            <router-link
              :to="{ path: operate.path }" v-show="operate.show">
              <div class="icon activebox_box">
                <img
                  :src="operate.icon2"
                  v-if="$route.path == operate.path"
                  style="margin-top: 12px"
				  class="activebox_box_img1"
                  alt=""
                />
                <img
					class="activebox_box_img2"
                  :src="operate.icon"
                  v-else
                  style="margin-top: 12px !important"
                />
              </div>
              <span class="iconSpan">{{ operate.label }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="col-8">
		<!-- <keep-alive> -->
			<router-view></router-view>
		<!-- </keep-alive> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExamManageLeft',
  data() {
    return {
      tx_setting: [
        {
          id: "1",
          label: "试题",
          icon: require("@/assets/tx/tab_def_icon1.png"),
          icon2: require("@/assets/tx/tab_sel_icon1.png"),
          path: "/createExam",
		  show:true
        },
        {
          id: "4",
          label: "外观",
          icon: require("@/assets/tx/tab_def_icon4.png"),
          icon2: require("@/assets/tx/tab_sel_icon4.png"),
          path: "/examAppearance",
		  show:true
        },
        {
          id: "5",
          label: "设置",
          icon: require("@/assets/tx/tab_def_icon5.png"),
          icon2: require("@/assets/tx/tab_sel_icon5.png"),
          path: "/examSetting",
		  show:true
        },
      ],
      height: 0,
    };
  },
  created() {
  	this.accessPermission();
  },
  mounted: function () {
    var winHeight =
      document.body.clientHeight || document.documentElement.clientHeight;
    this.height = winHeight - 108;
    this.rightheight = winHeight - 60;
    window.onresize = () => {
      var winHeight =
        document.body.clientHeight || document.documentElement.clientHeight;
      this.height = winHeight - 108;
      this.rightheight = winHeight - 60;
    };
  },
  methods: {
	  accessPermission() {
	  	let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
	  	// console.log(userInfo.permissionList);
	  	let arr = userInfo.permissionList;
	  	let permissionList = {};
	  	arr.forEach((item, index) => {
	  		permissionList['admin' + item] = item;
	  	});
	  	console.log(permissionList);
	  	// this.permissionList = permissionList;
	  	this.tx_setting.forEach(item=>{
	  		// 外观
	  		if(permissionList.admin1018){
	  			if(item.id == 4){
	  				item.show = true
	  			}
	  		}else{
	  			if(item.id == 4){
	  				item.show = false
	  			}
	  		}
	  		// 设置
	  		if(permissionList.admin1019){
	  			if(item.id == 5){
	  				item.show = true
	  			}
	  		}else{
	  			if(item.id == 5){
	  				item.show = false
	  			}
	  		}

	  	})
	  	
	  },
  },
};
</script>

<style scoped>

.iconActive span {
  color: #0080ff;
}
.iconActive .icon {
  background-color: #0080ff;
}
.wjTypeChild {
  width: 80px;
  background-color: #fff;
  padding-top: 15px;
  padding-bottom: 30px;
  float: left;
  display: inline;
  border-right: 2px solid #ccc;
}
.wjTypeChildItem {
  text-align: center;
  margin-top: 40px;
}
.icon {
  margin: 0px auto;
  width: 50px;
  height: 50px;
  border-radius: 5px;
}
.wjTypeChildItemFont {
  font-size: 14px;
  cursor: pointer;
}
.iconSpan {
  color: #666;
}
.setHeight {
  width: 80px;
  height: 100%;
  background-color: #fff;
  border-right: 2px solid #ccc;
  margin-top: 1px;
}
</style>